import { Injectable } from '@angular/core';
import { Response, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { WebService } from '../web.service';
import { DocumentProfileSurvey } from '../../class/document-profile-survey';

@Injectable()
export class DocumentProfileSurveyService extends WebService {

    public getDocumentProfileSurvey (page?: number, per_page?: number, sort?: string, query?: string, filters?: any[]): Observable<Response> {
        let params: URLSearchParams = new URLSearchParams();

        if (page !== null && page !== undefined) {
            params.append('_page', String(page));
        } else {
            params.append('_page', '1');
        }

        if (per_page !== null && per_page !== undefined) {
            params.append('_limit', String(per_page));
        } else {
            params.append('_limit', '10');
        }

        if (sort !== null && sort !== undefined) {
            params.append('_sort', String(sort));
        }

        if (query !== null && query !== undefined && query !== '') {
            params.append('_q', String(query));
        }

        if (filters !== null && filters !== undefined && filters.length > 0) {
            filters.forEach(element => {
                params.append(element.key, String(element.value));
            });
        }

        params.append('_with', String('profile_survey,list_doc_profile_survey,document_profile_survey'));

        const options = new RequestOptions({search: params, headers: this.headers});


        return this.http.get( `${this.apiUrl}/checklist-profile-surveis?${params}`, options);
    }

    public newDocumentProfileSurvey(body: Object): Observable<Response> {
        return this.http.post( `${this.apiUrl}/document-profile-surveis`, JSON.stringify(body) , { headers: this.headers } );
    }

    public updateDocumentProfileSurvey(id: number, body: Object): Observable<Response> {
        return this.http.patch( `${this.apiUrl}/document-profile-surveis/${id}`, JSON.stringify(body) , { headers: this.headers } );
    }

    public deleteDocumentProfileSurvey(id: number): Observable<Response> {
        return this.http.delete( `${this.apiUrl}/document-profile-surveis/${id}`, { headers: this.headers } );
    }

    public infoDocumentProfileSurvey(id: number): Observable<Response> {
        return this.http.get( `${this.apiUrl}/document-profile-surveis?id=${id}`,  { headers: this.headers } );
    }

    public getDocumentProfileSurveyExpired (page?: number, per_page?: number, sort?: string, query?: string, filters?: any[]): Observable<Response> {
        let params: URLSearchParams = new URLSearchParams();

        if (page !== null && page !== undefined) {
            params.append('_page', String(page));
        } else {
            params.append('_page', '1');
        }

        if (per_page !== null && per_page !== undefined) {
            params.append('_limit', String(per_page));
        } else {
            params.append('_limit', '10');
        }

        if (sort !== null && sort !== undefined) {
            params.append('_sort', String(sort));
        }

        if (query !== null && query !== undefined && query !== '') {
            params.append('_q', String(query));
        }

        if (filters !== null && filters !== undefined && filters.length > 0) {
            filters.forEach(element => {
                params.append(element.key, String(element.value));
            });
        }

        // params.append('_with', String('profile_survey,list_doc_profile_survey,document_profile_survey'));

        const options = new RequestOptions({search: params, headers: this.headers});
        return this.http.get( `${this.apiUrl}/document-profile-surveis/documents-expired?${params}`, options);
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/service/document-profile-survey/document-profile-survey.service.ts